<template>
  <div class="view-one-click-buy">
    <h5 class="text-semibold">Link one click buy</h5>
    <div class="bg-5 d-flex p-4 rounded-16 gap-2">
      <i class="ph ph-warning-circle fs-18" />
      <div>
        <div class="fs-14">Atenção</div>
        <div class="text-dark-40 fs-12">
          O link deve ser inserido no código da página de obrigado da primeira
          compra do seu cliente.
        </div>
      </div>
    </div>

    <snow-switch
      v-if="product"
      id="product-status"
      v-model="enable"
      label="Ativar/Desativar One Click Buy"
    />

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <div v-else-if="enable && product.charge_type === 'recurrent'">
      <action-dispatcher
        action="plan/get"
        :parameters="{ product_id: $route.params.id, limit: 100 }"
        class="d-flex flex-column gap-4"
      >
        <snow-links-inputs
          v-for="(plan, i) in plans"
          :key="`plan-link-${i}`"
          :product="product"
          :label="plan.name"
          :custom_url="plan.oneclick_url"
        />
      </action-dispatcher>
    </div>

    <div v-else-if="enable && product.type_product === 'onsite_event'">
      <action-dispatcher
        action="events/getLots"
        :parameters="{ product_id: $route.params.id, limit: 100 }"
        class="d-flex flex-column gap-4"
      >
        <snow-links-inputs
          v-for="(link, i) in eventLinks"
          :key="`event-link-${i}`"
          :product="product"
          :label="link.label"
          :custom_url="link.oneclick_url"
        />
        <div>
          <div class="d-flex flex-column align-items-center py-6">
            <img
              class="d-block mb-5 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <div class="mb-6">
              <small>
                Você ainda não tem ingressos cadastrados, clique no botão abaixo
                e cadastre o primeiro
              </small>
            </div>
            <snow-button
              text="Cadastrar"
              icon="ph ph-plus"
              @click="
                $router.push({
                  name: 'event-new-lot',
                  params: {
                    id: $route.params.id
                  }
                })
              "
            />
          </div>
        </div>
      </action-dispatcher>
    </div>

    <div v-else-if="enable" class="d-flex flex-column gap-4">
      <snow-links-inputs
        :product="product"
        :custom_url="product.oneclick_url"
        label="Oferta Principal"
      />
      <action-dispatcher
        action="offer/get"
        :parameters="{ product_id: $route.params.id, limit: 100 }"
        class="d-flex flex-column gap-4"
      >
        <snow-links-inputs
          v-for="(link, i) in offers"
          :key="`offer-link-${i}`"
          :product="product"
          :label="link.name"
          :custom_url="link.oneclick_url"
        />
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  data() {
    let offer = "";
    if (this.$route.query.offer && this.$route.query.offer !== "padrao") {
      offer = this.$route.query.offer;
    }
    let plan = "";
    if (this.$route.query.plan && this.$route.query.plan !== "padrao") {
      plan = this.$route.query.plan;
    }
    return {
      loading: false,
      filters: {
        plan,
        offer,
        group: ""
      }
    };
  },
  computed: {
    ...mapState("membersGroups", ["groupsFilter"]),
    ...mapState("product", ["product"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("events", ["lots"]),
    enable: {
      get() {
        return (
          this.product &&
          (this.product.enable_oneclickbuy ||
            (this.loading && !this.product.enable_oneclickbuy))
        );
      },
      set(value) {
        this.loading = true;
        this.$store
          .dispatch("product/put", {
            id: this.product.id,
            enable_oneclickbuy: value
          })
          .catch(() => {
            this.$message.error(
              "Não foi possível ativar a funcionalidade One Click Buy"
            );
            this.enable = !value;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    plan() {
      return this.plans.find(plan => plan.id === this.filters.plan);
    },
    offer() {
      return this.offers.find(offer => offer.id === this.filters.offer);
    },
    group() {
      return this.groupsFilter.find(group => group.id === this.filters.group);
    },
    eventLinks() {
      return this.lots.map(t => ({ ...t, label: t.name }));
    }
  },
  watch: {
    "filters.offer"() {
      this.filters.group = null;
    },
    "filters.plan"() {
      this.filters.group = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-one-click-buy {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: var(--bg-2);
  padding: 24px;
  border-radius: 16px;
}
</style>
